/* ═══════════════════════════════════════════════════════════════
 * ORDER FLOW — live trade-stream + Cumulative Volume Delta (CVD)
 * 1:1 poort van TERMINAL.orderFlow uit terminal_wyckoffpcg.html.
 * Perf: trades bufferen en 1× per animatieframe naar de DOM flushen,
 * lijst gecapt op CFG.maxTrades regels. Blijft bewust buiten React's
 * render-cyclus — direct op refs naar de dock-DOM, zoals het origineel.
 * ═══════════════════════════════════════════════════════════════ */

import { CONFIG as CFG } from "./config";

const C = CFG.colors;

// listEl: container voor de trade-rijen
// cvdEl: element dat de CVD-waarde toont
// statsEl: element met [data-buy]/[data-sell] (breedte) en
//          [data-buylbl]/[data-selllbl] (percentage-tekst) children
export function createOrderFlow(listEl, cvdEl, statsEl) {
  let buffer = [];
  let flushPending = false;
  let cvd = 0;
  let cvdHistory = [];
  let buyVol = 0, sellVol = 0;

  function reset() {
    buffer = [];
    cvd = 0; cvdHistory = [];
    buyVol = 0; sellVol = 0;
    if (listEl) listEl.innerHTML = "";
    renderCvd(); renderStats();
  }

  function pushTrade(t) {
    if (t.isBuy) { cvd += t.qty; buyVol += t.qty; }
    else { cvd -= t.qty; sellVol += t.qty; }
    cvdHistory.push(cvd);
    if (cvdHistory.length > CFG.maxCvdPoints) cvdHistory.shift();

    buffer.push(t);
    if (!flushPending) { flushPending = true; requestAnimationFrame(flush); }
  }

  function flush() {
    flushPending = false;
    if (!buffer.length) return;
    const batch = buffer; buffer = [];

    const frag = document.createDocumentFragment();
    for (let i = batch.length - 1; i >= 0; i--) {
      const t = batch[i];
      const row = document.createElement("div");
      row.className = "of-row " + (t.isBuy ? "buy" : "sell");
      const time = new Date(t.time);
      const hh = String(time.getHours()).padStart(2, "0");
      const mm = String(time.getMinutes()).padStart(2, "0");
      const ss = String(time.getSeconds()).padStart(2, "0");
      row.innerHTML =
        `<span class="of-time">${hh}:${mm}:${ss}</span>` +
        `<span class="of-price">${t.price.toFixed(2)}</span>` +
        `<span class="of-qty">${t.qty.toFixed(3)}</span>`;
      frag.appendChild(row);
    }
    if (listEl) {
      listEl.insertBefore(frag, listEl.firstChild);
      while (listEl.children.length > CFG.maxTrades) {
        listEl.removeChild(listEl.lastChild);
      }
    }
    renderCvd(); renderStats();
  }

  function renderCvd() {
    if (!cvdEl) return;
    const pos = cvd >= 0;
    cvdEl.textContent = (pos ? "+" : "") + cvd.toFixed(2);
    cvdEl.style.color = pos ? C.buy : C.sell;
  }

  function renderStats() {
    if (!statsEl) return;
    const tot = buyVol + sellVol || 1;
    const bp = Math.round((buyVol / tot) * 100);
    const buyBar = statsEl.querySelector("[data-buy]");
    const sellBar = statsEl.querySelector("[data-sell]");
    const buyLbl = statsEl.querySelector("[data-buylbl]");
    const sellLbl = statsEl.querySelector("[data-selllbl]");
    if (buyBar) buyBar.style.width = bp + "%";
    if (sellBar) sellBar.style.width = (100 - bp) + "%";
    if (buyLbl) buyLbl.textContent = bp + "%";
    if (sellLbl) sellLbl.textContent = (100 - bp) + "%";
  }

  return { pushTrade, reset, getCvd: () => cvd, getCvdHistory: () => cvdHistory };
}
